import React from 'react'
import { useDispatch } from 'react-redux';
import { handleSelectDate } from '../actions'
import DatePicker from "react-datepicker"

import "react-datepicker/dist/react-datepicker.css";

const DateSelector = ({restaurantId, date}) => {
    const dispatch = useDispatch();
    return (
        <DatePicker selected={date} onSelect={date => {
            dispatch(handleSelectDate(restaurantId, date))
        }}/>
    )
}

export default DateSelector